/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
import React from "react";
import { NavLink } from "react-router-dom";

const FooterCopyright = () => {
    //TODO: SC-2340 - Fill out URLs when ready
    return (
        <div className="footer-copyright">
            <div className="footer-copyright-content">
                <span>&copy; 2025 District of Kitimat</span>
                <div className="footer-copyright-links">
                    <span className="built-with-simplicity">
                        Built with&nbsp;
                        <a
                            href="https://www.simplicitycms.ca/"
                            target="_blank"
                        >
                            SimpliCity
                        </a>
                        <sup>&trade;</sup>
                    </span>
                    <NavLink
                        aria-label="Sitemap"
                        to="/"
                    >
                        Sitemap
                    </NavLink>
                    <NavLink
                        aria-label="Website Feedback"
                        to="/"
                    >
                        Website Feedback
                    </NavLink>
                </div>
            </div>
        </div>
    );
};

export { FooterCopyright };
